import axios from 'axios';

const API_BASE = '/api/profile';

export interface ProfileAnswersPayload {
  assessmentResultId?: number;
  roles: string[];
  events: { sports: string[]; nonSports: string[] };
  keywords: string[];
  behavior: { hardExperience: string; overcomingMethod: string; teamRole: string };
  dualCareer: {
    practice: string; competition: string; competitionPriority: string;
    workStyle: string; balanceOrientation: string; nonNegotiable: string;
  };
}

export const profileService = {
  async createTransitionToken(assessmentResultId: number): Promise<{ token: string }> {
    const res = await axios.post(`${API_BASE}/create-transition-token.php`, { assessmentResultId });
    return res.data.data;
  },

  async saveAnswers(data: ProfileAnswersPayload): Promise<{ success: boolean }> {
    const res = await axios.post(`${API_BASE}/save-answers.php`, data);
    return res.data;
  },

  async generate(assessmentResultId?: number): Promise<{ success: boolean; data: any }> {
    const res = await axios.post(`${API_BASE}/generate.php`, { assessmentResultId });
    return res.data;
  },

  async getMyProfile(): Promise<{ success: boolean; data: any }> {
    const res = await axios.get(`${API_BASE}/me.php`);
    return res.data;
  },

  async updatePrivacy(privacyState: 'private' | 'anonymous_public'): Promise<{ success: boolean }> {
    const res = await axios.put(`${API_BASE}/update-privacy.php`, { privacyState });
    return res.data;
  },
};
